import React, { Component } from "react";
import QuizScreen from "./QuizScreen"
import dataJSON from "../../api/data.json"
import { push } from "../Services/Analytics"
import Helmet from "react-helmet"

import "./Hidon.scss"

class Hidon extends Component {
    constructor() {
        super();
        this.state = {
            Takanon: {
                name: "Takanon",
                value: 0,
                error: null,
                Proxy: 0
            },
            isDetailsFilled: false
        }
        this.startHidon = this.startHidon.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    handleInputChange(event) {
        this.setState({
            [event.target.name]: {
                name: event.target.name,
                value: event.target.value,
                error: null
            }
        })
        if (event.target.name == "Takanon") {
            this.setState({
                Takanon: {
                    name: event.target.name,
                    value: (this.state[event.target.name].value ? 0 : 1),
                }
            })
        }
    }
    startHidon() {
        // const state = this.state;

        // if (!state.Takanon.value) {
        //     this.props.triggerPopup({
        //         Title: "כדי להמשיך לפעילות יש להסכים לתקנון"
        //     });
        //     return;
        // }
        push("Start_Quiz_Button", "");
        this.setState({
            isDetailsFilled: true
        })
    }
    render() {
        switch (this.state.isDetailsFilled) {
            case false:
                return (
                    <section className="section section-form">
                        <div className="padding">
                            <div className="container">
                                <div className="headline">
                                    <div className="head">
                                        {dataJSON.headline}
                                    </div>
                                    <div className="desc">
                                        {/* {dataJSON.desc} */}
                                    </div>
                                </div>
                                <div className="form">
                                    {/* <DomCheckboxField type="checkbox" name="Takanon" id="Takanon" onChange={this.handleInputChange} {...this.state} /> */}
                                    <div className="button" onClick={this.startHidon}>
                                        <div className="button-text">
                                            {dataJSON.button.text}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )
                break;
            case true:
                return (
                    <QuizScreen hidonState={this.props.hidonState} Takanon={this.state.Takanon} />
                )
                break;
        }
    }
}

const DomCheckboxField = (props) => {
    return (
        <div className="field checkbox">
            <input type={props.type} placeholder={props.placeholder} name={props.name} id={props.id} value={1} onChange={props.onChange} />
            <label htmlFor={props.id}>קראתי והבנתי את <a href="https://z.ynet.co.il/mShort/commerce/2018/HidonNespressoAPI/takanon.htm" title="" target="_blank">תקנון</a> ההשתתפות בשאלון</label>
        </div>
    )
}

export default Hidon;



// WEBPACK FOOTER //
// ./src/Components/Hidon/Hidon.js